import { useEffect, useState } from 'react';
import './Sidebar.css';

interface NavItem {
  id: string;
  title: string;
  category: string;
}

const navItems: NavItem[] = [
  { id: 'button', title: 'Button 按钮', category: '通用' },
  { id: 'input', title: 'Input 输入框', category: '数据录入' },
  { id: 'textarea', title: 'Textarea 文本域', category: '数据录入' },
  { id: 'card', title: 'Card 卡片', category: '数据展示' },
  { id: 'badge', title: 'Badge 徽章', category: '数据展示' },
  { id: 'dialog', title: 'Dialog 对话框', category: '反馈' },
  { id: 'alert', title: 'Alert 警告提示', category: '反馈' },
  { id: 'message', title: 'Message 全局提示', category: '反馈' },
  { id: 'loading', title: 'Loading 加载中', category: '反馈' },
];

export default function Sidebar() {
  const [activeId, setActiveId] = useState<string>('button');

  useEffect(() => {
    const handleScroll = () => {
      const headerHeight = 60;
      const scrollPosition = window.scrollY + headerHeight + 50;

      for (let i = navItems.length - 1; i >= 0; i--) {
        const element = document.getElementById(navItems[i].id);
        if (element) {
          const elementTop = element.offsetTop;
          if (scrollPosition >= elementTop) {
            setActiveId(navItems[i].id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const headerHeight = 60;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setActiveId(id);
    }
  };

  const groupedItems = navItems.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {} as Record<string, NavItem[]>);

  return (
    <nav className="sidebar">
      <div className="sidebar-content">
        {Object.entries(groupedItems).map(([category, items]) => (
          <div key={category} className="sidebar-group">
            <div className="sidebar-group-title">{category}</div>
            {items.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className={`sidebar-item ${activeId === item.id ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(item.id);
                }}
              >
                {item.title}
              </a>
            ))}
          </div>
        ))}
      </div>
    </nav>
  );
}
